(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_a5ada65"] && !Shopify.designMode) return;
  try {
    (function () {
  const DOT_THRESHOLD = 15;

  function getVisibleSlideCount(gallery) {
    const slides = gallery.querySelectorAll('slideshow-slide');
    let visible = 0;
    slides.forEach((slide) => {
      const mediaContainer = slide.querySelector('[data-media-id]');
      if (mediaContainer) {
        if (mediaContainer.style.display !== 'none') visible++;
      } else {
        if (slide.style.display !== 'none') visible++;
      }
    });
    return visible > 0 ? visible : slides.length;
  }

  function buildDotsHTML(count) {
    let items = '';
    for (let i = 0; i < count; i++) {
      const sel = i === 0 ? 'aria-selected="true"' : '';
      items += `<li><button class="slideshow-control button button-unstyled" style="animation-timeline: --slide-${i}" aria-label="Slide ${i + 1} of ${count}" on:click="/select/${i}" ref="dots[]" ${sel}>${i + 1}</button></li>`;
    }
    return `<ol class="slideshow-controls__dots">${items}</ol>`;
  }

  function buildCounterHTML(count) {
    return `<div class="slideshow-controls__counter"><span ref="current">1</span><span class="slash">/</span>${count}</div>`;
  }

  function updatePaginationStyle(gallery) {
    const controls = gallery.querySelectorAll('slideshow-controls');
    if (!controls.length) return;
    const visibleCount = getVisibleSlideCount(gallery);

    controls.forEach((ctrl) => {
      const existingDots = ctrl.querySelector('.slideshow-controls__dots');
      const existingCounter = ctrl.querySelector('.slideshow-controls__counter');
      if (existingDots) existingDots.remove();
      if (existingCounter) existingCounter.remove();

      if (visibleCount <= 1) return;

      const html = visibleCount <= DOT_THRESHOLD
        ? buildDotsHTML(visibleCount)
        : buildCounterHTML(visibleCount);

      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newNode = tmp.firstElementChild;

      const arrowsAfter = ctrl.querySelector('.slideshow-controls__arrows:last-child');
      if (arrowsAfter) {
        ctrl.insertBefore(newNode, arrowsAfter);
      } else {
        ctrl.appendChild(newNode);
      }
    });
  }

  function attachToGallery(gallery) {
    if (gallery._bmaObserver) gallery._bmaObserver.disconnect();
    updatePaginationStyle(gallery);

    const observer = new MutationObserver(() => {
      updatePaginationStyle(gallery);
    });
    observer.observe(gallery, {
      attributes: true,
      attributeFilter: ['style'],
      subtree: true,
    });
    gallery._bmaObserver = observer;
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(attachToGallery);
  }

  function watchForGalleryReplacements() {
    document.querySelectorAll('.shopify-section').forEach((section) => {
      const mo = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'MEDIA-GALLERY') {
              attachToGallery(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('media-gallery').forEach(attachToGallery);
            }
          });
        });
      });
      mo.observe(section, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initAll(); watchForGalleryReplacements(); });
  } else {
    initAll();
    watchForGalleryReplacements();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
